//请自行添加语言资源
const truck = {
  truckCode: '车牌号',
  plateColor: '车牌颜色',
  truckType: '车牌类型',
  sinoiovNetworkJoinStatus: '是否中交入网',
  companyCode: '机构编码',
  companyName: '机构名称',
  carrierCode: '承运商编码',
  carrierName: '承运商名称',
  loadWeight: '核载重量',
  loadVolume: '核载体积',
  remark: '备注',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  useCompanyName: '使用机构',
  gpsFlag: '需要获取轨迹',
  activeOff: '是否启用',
  msg: {
    truckCode: '请选择车牌号',
    plateColor: '请选择车辆颜色',
    truckType: '请选择车辆类型',
    companyCode: '请选择机构名称',
    carrierCode: '请选择承运商名称',
    loadWeight: '请输入核载重量',
    loadVolume: '请输入核载体积',
    remark: '请输入核载体积',
    number: '格式只能为数字，且最多只能有三位小数',
    length: '备注长度不能超过100个字'
  }
};
export default truck



// WEBPACK FOOTER //
// ./src/page/mdm/truck/lang/truck.zh.js